import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { useDispatch, useSelector } from 'react-redux';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import UISelect from 'UIComponents/input/UISelect';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { EndpointKey } from '../http/EndpointKey';
import { isEndpointStatusError } from '../store/http-responses/selectors';
import { updateCurrencyCode } from '../store/pricing/action-creators';
import { getCurrencyCode } from '../store/pricing/selectors';
import { useTracker } from '../tracking/useTracker';
import { Step } from '../views/Step';
const AVAILABLE_CURRENCIES = Object.values(CurrencyCodes);
export const CurrencyPicker = () => {
  const dispatch = useDispatch();
  const {
    currentStep
  } = useCurrentStep();
  const activeCurrencyCode = useSelector(getCurrencyCode);
  const isPricingStep = currentStep === Step.Pricing;
  const isPricingEndpointError = useSelector(isEndpointStatusError(EndpointKey.PricingProducts) || isEndpointStatusError(EndpointKey.PricingPromotions));
  const Tracker = useTracker();

  if (!isPricingStep || isPricingEndpointError) {
    return null;
  }

  const getCurrencyOptions = () => AVAILABLE_CURRENCIES.map(availableCurrency => ({
    text: `${availableCurrency} (${I18n.currencySymbols[availableCurrency].symbol})`,
    value: availableCurrency
  }));

  const handleChange = ({
    target: {
      value: currency
    }
  }) => {
    dispatch(updateCurrencyCode(currency));
    Tracker.signupInteraction('selected-currency', {
      currency
    });
  };

  return /*#__PURE__*/_jsx(UISelect, {
    buttonUse: "transparent",
    className: "display-inline-block",
    "data-selenium-id": "currency-picker",
    id: "currency",
    menuStyle: {
      minHeight: 320,
      color: '#0b8484 !important'
    },
    menuWidth: 200,
    options: getCurrencyOptions(),
    value: activeCurrencyCode,
    onChange: handleChange
  });
};